export default __webpack_public_path__ + "assets/resizedpopularCities_2-min.456d748b.webp";